"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var framer_motion_1 = require("framer-motion");
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
var DrawerHeader_1 = require("./DrawerHeader");
var DrawerFooter_1 = require("./DrawerFooter");
var DrawerWindow_1 = require("./DrawerWindow");
var utilities_1 = require("../../utilities");
var internal_1 = require("../../internal");
var hooks_1 = require("../../hooks");
var focus_utils_1 = require("../../utilities/focus-utils");
var Drawer = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, footer = _a.footer, footerAlign = _a.footerAlign, header = _a.header, onClose = _a.onClose, open = _a.open, _c = _a.portal, portal = _c === void 0 ? true : _c, backdrop = _a.backdrop, _d = _a.width, width = _d === void 0 ? 's' : _d, focusScopeOptions = _a.focusScopeOptions, rest = __rest(_a, ["children", "className", "footer", "footerAlign", "header", "onClose", "open", "portal", "backdrop", "width", "focusScopeOptions"]);
    var overlayContext = react_1.useContext(utilities_1.OverlayContext);
    var drawerRef = react_1.useRef(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var lastActiveElement = react_1.useMemo(function () { return focus_utils_1.getActiveElement(); }, [open]);
    var handleTab = hooks_1.useFocusScope(drawerRef, __assign({ disableAutofocus: !open, disableTrapping: !open, restoreFocusRef: { current: lastActiveElement } }, focusScopeOptions)).handleTab;
    var DrawerClasses = classnames_1.default('Drawer', className, (_b = {
            'Drawer--open': open,
            'Drawer--portal': portal || backdrop,
            'Drawer--close': !open
        },
        _b["Drawer--w-" + width] = width,
        _b));
    var durationSlow = parseInt(tokens_1.default.durationSlow, 10) / 1000; // '300ms' -> 0.3
    var drawerAnimation = {
        initial: { opacity: 0, x: '100%' },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: '100%' },
        transition: { type: 'easeInOut', duration: durationSlow },
    };
    var drawerContent = (react_1.default.createElement(framer_motion_1.motion.div, __assign({ className: DrawerClasses, ref: drawerRef, onKeyDown: handleTab }, drawerAnimation, rest),
        react_1.default.createElement(utilities_1.OverlayContext.Provider, { value: overlayContext.concat('drawer') },
            header && (react_1.default.createElement(DrawerHeader_1.DrawerHeader, { onClose: onClose }, header)),
            react_1.default.createElement("div", { className: "Drawer__content" }, children),
            footer && (react_1.default.createElement(DrawerFooter_1.DrawerFooter, { align: footerAlign }, footer)))));
    var drawer = backdrop ? (react_1.default.createElement(DrawerWindow_1.DrawerWindow, { animate: true, onClose: onClose }, drawerContent)) : (react_1.default.createElement(framer_motion_1.AnimatePresence, null, drawerContent));
    return open && react_1.default.createElement(internal_1.Portal, { conditional: portal && !backdrop }, drawer);
};
exports.Drawer = Drawer;
exports.Drawer.Header = DrawerHeader_1.DrawerHeader;
exports.Drawer.Footer = DrawerFooter_1.DrawerFooter;
exports.Drawer.Window = DrawerWindow_1.DrawerWindow;
//# sourceMappingURL=Drawer.js.map